<script setup lang="ts">
import { useI18n } from '@/hooks/web/useI18n';
import { ElDialog } from 'element-plus'
import { ref, watch, computed } from 'vue';
import { useAppStore } from '@/store/modules/app'
const { t } = useI18n()

const props = defineProps({
  title: String,
  show: {type: Boolean, default: false},
  loading: {type: Boolean, default: false},
  canConfirm: {type: Boolean, default: false},
  width: {type: String, default: '816px'},
  top: {type: String, default: '15vh'},
  appendToBody: {type: Boolean, default: false},
  showFooter: {type: Boolean, default: true},
  showConfirm: {type: Boolean, default: true},
  showCancel: {type: Boolean, default: true},
  showClose: {type: Boolean, default: true},
  cancelColor: {type: String, default: 'var(--c-gray-dark)'},
  confirmActiveColor: {type: String, default: 'var(--left-menu-text-active-color)'},
  cancelText: {type: String, default: ''},
  confirmText: {type: String, default: ''},
  bodyPadding: {type: String, default: ''},
  titleHeight: {type: String, default: ''}
})

// const _cancel_text = ref(props.cancelText?props.cancelText:t('common.cancel'))
// const _confirm_text = ref(props.confirmText?props.confirmText:t('common.confirm'))

const emit = defineEmits(['update:show', 'update:loading', 'confirm', 'cancel', 'open', 'close'])

// 双向数据绑定
const _show = ref(props.show)
watch(_show, val => { emit('update:show', val) }, { immediate: true })
watch(()=>props.show, val => { _show.value = val }, { immediate: true })
const _loading = ref(props.loading)
watch(_loading, val => { emit('update:loading', val) }, { immediate: true })
watch(()=>props.loading, val => { _loading.value = val }, { immediate: true })

const confirm = () => { emit('confirm') }
const cancel = () => { emit('cancel') }
const open = () => { emit('open') }
const close = () => { emit('close') }

// 是否是移动端

const appStore = useAppStore()
const mobile = computed(() => appStore.getMobile)
</script>

<template>
  <ElDialog
    class="asp-dialog"
    v-model="_show"
    :width="width"
    :top="top"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :fullscreen="mobile"
    @open="open"
    @close="close">
    <div v-loading="_loading" class="h-full flex flex-col">
      <!-- title -->
      <div :style="{height:titleHeight}" class="flex-shrink-0 flex-grow-0 flex items-center px-[24px] py-[17px] box-border bg-[var(--c-content-bg-gray)] border-b-[1px] border-[var(--c-card-content-border-gray)]">
        <div class="text-[18px] font-bold text-[var(--left-menu-text-color)]">{{title}}</div>
        <slot name="title"></slot>
        <img v-if="showClose" class="w-[16px] h-[16px] ml-[auto] cursor-pointer" src="@/assets/icons/icon-dialog-close.svg" @mousedown="_show=false;emit('close')"/>
      </div>
      <!-- body -->
      <div :class="bodyPadding" class="flex-1 overflow-auto bg-[var(--c-white)] box-border">
        <slot></slot>
      </div>
      <!-- footer -->
      <div v-if="showFooter" class="flex-shrink-0 flex-grow-0 h-[40px] flex items-center justify-end px-[24px] box-border font-bold bg-[var(--c-content-bg-gray)] border-t-[1px] border-[var(--c-card-content-border-gray)]">
        <div
          v-if="showCancel"
          @mousedown="cancel"
          :style="{color: cancelColor}"
          class="text-[14px] cursor-pointer mr-[32px]">
          {{props.cancelText?props.cancelText:t('common.Cancel')}}
        </div>
        <div
          v-if="showConfirm"
          @mousedown="confirm"
          :style="{color: (canConfirm?confirmActiveColor:'var(--c-card-content-border-gray)')}"
          :class="canConfirm?'':'pointer-events-none'"
          class="text-[14px] cursor-pointer">
          {{props.confirmText?props.confirmText:t('common.Confirm')}}
        </div>
      </div>
    </div>
  </ElDialog>
</template>
